import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowX: "hidden",
  },
  item: {
    position: "relative",
    borderRadius: theme.radius.medium,
    minHeight: 320,
    minWidth: 310,
  },
  content: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `${theme.spacing.space24}px ${theme.spacing.space20}px`,
    boxSizing: "border-box",
    border: "2px solid rgba(52, 59, 79, 0.30)",
    borderRadius: theme.radius.medium,
  },
  action: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    height: 20,
  },
  dialog: {
    gap: theme.spacing.space24,
  },
  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
  },
  img: {
    height: 320,
    borderRadius: theme.radius.medium,
    border: "1px solid rgba(52, 59, 79, 0.30)",
  },
  sliderContainer: {
    height: 330,
    overflowY: "hidden",
    "& div.slick-list div.slick-track div.slick-slide": {
      marginRight: theme.spacing.space16,
    },
    "& div.slick-list": {
      padding: `${theme.spacing.space4}px ${theme.spacing.space16}px`,
      scrollPaddingLeft: `${theme.spacing.space16}px !important`,
    },
  },
  sliderStatic: {
    display: "flex",
    gap: theme.spacing.space16,
    padding: `${theme.spacing.space4}px ${theme.spacing.space16}px`,
    scrollPaddingLeft: `${theme.spacing.space16}px !important`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  dots: {
    marginTop: theme.spacing.space16,
    marginLeft: theme.spacing.space16,
    justifyContent: "left !important",
  },
}));
